import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="animate-pulse space-y-4">
      {/* Skeleton for Search and Filter Bar */}
      <div className="flex w-full justify-between gap-2.5">
        <div className="w-full flex bg-gray-100 rounded-lg items-center px-2 h-12"></div>
        <div className="w-12 h-12 bg-gray-100 rounded-full"></div>
      </div>

      {/* Skeleton for Table Header */}
      <div className="table-header flex space-x-4">
        <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
        <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
        <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
        <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
        <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
        <div className="w-16 h-6 bg-gray-100 rounded-lg"></div>
      </div>

      {/* Skeleton for Table Rows */}
      <div className="space-y-4">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="flex items-center space-x-4">
            <div className="w-8 h-8 bg-gray-100 rounded-full"></div>
            <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
            <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
            <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
            <div className="w-32 h-6 bg-gray-100 rounded-lg"></div>
            <div className="w-16 h-6 bg-gray-100 rounded-lg"></div>
          </div>
        ))}
      </div>

      {/* Skeleton for Pagination */}
      <div className="w-32 h-8 bg-gray-100 rounded-lg mt-6"></div>
    </div>
  );
};

export default SkeletonLoader;
